import { 
  WAIT_INIT_MAP, GET_COUNTRY_QUANTITY, GET_COUNTRY_QUANTITY_SUCCESS, GET_COUNTRY_QUANTITY_FAIL, GET_STATE_QUANTITY, GET_STATE_QUANTITY_SUCCESS, GET_STATE_QUANTITY_FAIL, 
  GET_CITY_QUANTITY, GET_CITY_QUANTITY_SUCCESS, GET_CITY_QUANTITY_FAIL, QUERY_DEVICES, QUERY_DEVICES_SUCCESS, QUERY_DEVICES_FAIL
} from '../actions/map/index';

import { DO_ACTIVE_PAGE } from '../actions/menu/index';

import { 
  GET_DEVICE_DETAIL, GET_DEVICE_DETAIL_SUCCESS, CLOSE_DEVICE_STATUS
} from '../actions/dashboard/index';

const doMap = (state, action) => {
  switch (action.type) {
    case DO_ACTIVE_PAGE:
      return {
        ...state,
        devices: [],
        errMsg: null,
        status: WAIT_INIT_MAP,
        displayDetail: false,
        loading: true,
        countryLoading: true,
        monitorOnline: 0,
        monitorOffline: 0
      }
    case WAIT_INIT_MAP:
      return {
        ...state,
        devices: [],
        errMsg: null,
        status: WAIT_INIT_MAP,
        displayDetail: false,
        loading: true,
        countryLoading: true,
        monitorOnline: 0,
        monitorOffline: 0
      }
    case GET_COUNTRY_QUANTITY:
      return {
        ...state,
        devices: [],
        errMsg: null,
        status: GET_COUNTRY_QUANTITY,
        displayDetail: false,
        countryQuantity: [],
        countryLoading: true,
        monitorOnline: 0,
        monitorOffline: 0,
        deviceLoading: true
      }
    case GET_COUNTRY_QUANTITY_SUCCESS:
      return {
        ...state,
        errMsg: null,
        status: GET_COUNTRY_QUANTITY_SUCCESS,
        countryLoading: false,
        monitorOnline: action.params.monitorOnline,
        monitorOffline: action.params.monitorOffline,
        countryQuantity: action.params.countryQuantity,
      }
    case GET_COUNTRY_QUANTITY_FAIL:
      return {
        ...state,
        devices: [],
        errMsg: action.params.errMsg,
        status: GET_COUNTRY_QUANTITY_FAIL,
        countryQuantity: [],
        countryLoading: false
      }
    case GET_STATE_QUANTITY:
      let stateQuantityMap = state.stateQuantityMap;
      stateQuantityMap[action.params.countryName] = [];
      let stateLoadingMap = state.stateLoadingMap;
      stateLoadingMap[action.params.countryName] = {};

      return {
        ...state,
        devices: [],          
        errMsg: null,
        status: GET_STATE_QUANTITY,
        displayDetail: false,
        stateQuantityMap: stateQuantityMap,
        stateLoadingMap: stateLoadingMap,
        deviceLoading: true
      }
    case GET_STATE_QUANTITY_SUCCESS:
      let stateQuantityMapSuccess = state.stateQuantityMap;
      stateQuantityMapSuccess[action.params.countryName] = action.params.stateQuantity;
      let stateLoadingMapSuccess = state.stateLoadingMap;
      stateLoadingMapSuccess[action.params.countryName] = action.params.stateLoading;

      return {
        ...state,
        errMsg: null,
        status: GET_STATE_QUANTITY_SUCCESS,
        stateQuantityMap: stateQuantityMapSuccess,
        stateLoadingMap: stateLoadingMapSuccess
      }
    case GET_STATE_QUANTITY_FAIL:
        let stateQuantityMapFail = state.stateQuantityMap;
        stateQuantityMapFail[action.params.countryName] = [];
        let stateLoadingMapFail = state.stateLoadingMap;
        stateLoadingMapFail[action.params.countryName] = {};

      return {
        ...state,
        devices: [],
        errMsg: action.params.errMsg,
        status: GET_STATE_QUANTITY_FAIL,
        stateQuantityMap: stateQuantityMapFail,
        stateLoadingMap: stateLoadingMapFail
      }
    case GET_CITY_QUANTITY:
      let cityQuantityMap = state.cityQuantityMap;
      cityQuantityMap[action.params.stateName] = [];
      let cityLoadingMap = state.cityLoadingMap;
      cityLoadingMap[action.params.stateName] = {};

      return {
        ...state,
        devices: [],          
        errMsg: null,
        status: GET_CITY_QUANTITY,
        displayDetail: false,
        cityQuantityMap: cityQuantityMap,
        cityLoadingMap: cityLoadingMap
      }
    case GET_DEVICE_DETAIL:
      return {
        ...state,        
        status: GET_DEVICE_DETAIL,
        displayDetail: true,
        detailLoading: true,
      }
    case GET_DEVICE_DETAIL_SUCCESS:
      return {
        ...state,
        status: GET_DEVICE_DETAIL_SUCCESS,
        detailLoading: false,
      }
    case CLOSE_DEVICE_STATUS:
      return {
        ...state,
        status: CLOSE_DEVICE_STATUS,
        displayDetail: false,
        detailLoading: true
      }
    case GET_CITY_QUANTITY_SUCCESS:
      let cityQuantityMapSuccess = state.cityQuantityMap;
      cityQuantityMapSuccess[action.params.stateName] = action.params.cityQuantity;
      let cityLoadingMapSuccess = state.cityLoadingMap;
      cityLoadingMapSuccess[action.params.stateName] = action.params.cityLoading;

      return {
        ...state,
        errMsg: null,
        status: GET_CITY_QUANTITY_SUCCESS,
        cityQuantityMap: cityQuantityMapSuccess,
        cityLoadingMap: cityLoadingMapSuccess
      }
    case GET_CITY_QUANTITY_FAIL:
        let cityQuantityMapFail = state.cityQuantityMap;
        cityQuantityMapFail[action.params.stateName] = [];
        let cityLoadingMapFail = state.cityLoadingMap;
        cityLoadingMapFail[action.params.stateName] = {};

      return {
        ...state,
        devices: [],
        errMsg: action.params.errMsg,
        status: GET_CITY_QUANTITY_FAIL,
        cityQuantityMap: cityQuantityMapFail,
        cityLoadingMap: cityLoadingMapFail
      }
    case QUERY_DEVICES:
      return {
        ...state,        
        errMsg: null,
        status: QUERY_DEVICES,
        devices: [],
        deviceLoading: true,
        displayDetail: false
      }
    case QUERY_DEVICES_SUCCESS:
      return {
        ...state,        
        errMsg: null,
        status: QUERY_DEVICES_SUCCESS,
        deviceLoading: false,
        devices: action.params.devices
      }
    case QUERY_DEVICES_FAIL:
      return {
        ...state,
        errMsg: action.params.errMsg,
        status: QUERY_DEVICES_FAIL,
        devices: [],
        deviceLoading: false
      }
  default:
      return state;
    }
}

const mapReducers = (state = {  
  monitorOnline: 0,
  monitorOffline: 0,
  countryQuantity: [],
  countryLoading: true,
  stateQuantityMap: {},
  stateLoadingMap: {},
  cityQuantityMap: {},
  cityLoadingMap: {},
  errMsg: null,
  successMsg: null,
  status: WAIT_INIT_MAP,
  devices: [],
  deviceLoading: true
}, action) => {
  switch (action.type) {
    default:
      return doMap(state, action);
  }
}

export default mapReducers;